export default "__VITE_ASSET__c9UwMndU__"